/**
 * Detach codec for the article `fb_savedforms_id` field.
 *
 * The async-select driver represents "no selection" as `''` (its clear button emits `''`), but
 * the legacy schema uses the integer sentinel `0` for "no form attached" (and the article
 * fixtures store `fb_savedforms_id: 0`). This codec bridges the two so detaching a form persists
 * the legacy sentinel while the UI shows an empty (placeholder) select.
 *
 * - `parse(wire)`: `0 | '0' | null | undefined | ''` → `''` (empty UI selection); any other
 *   value → its string form (so the async-select can match it against an option/`resolveLabel`).
 * - `serialize(ui)`: `'' | null | undefined` → `0`; otherwise the numeric id when the value is a
 *   clean integer string, else the value as-is (defensive — never throws).
 *
 * @returns {import('../../contracts/forms.js').FieldCodec}
 */
export function createFbFormIdCodec() {
  return {
    /** @param {unknown} wireValue */
    parse(wireValue) {
      if (wireValue === 0 || wireValue === '0' || wireValue == null || wireValue === '') return '';
      return String(wireValue);
    },
    /** @param {unknown} uiValue */
    serialize(uiValue) {
      if (uiValue == null || uiValue === '') return 0;
      const s = String(uiValue).trim();
      if (s === '') return 0;
      return /^\d+$/.test(s) ? Number(s) : uiValue;
    },
  };
}
